export function cleanQuestionQuizOptionText(question: string): string {
	if (!question) {
		return '';
	}

	return question
		.replace(/^\s*(?:Q(?:uestion)?[\s.-]*)?\d+[\s.)\-:]*\s*/i, '')
		.trim();
}
